import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BASE_API_URL } from '@cnt-workspace/data-access';
import { IGuestBanDetail, ISuccessMessage } from '@curbnturf/entities';
import { Observable } from 'rxjs';

const API_URL = BASE_API_URL + 'rating';

/** The admin-only half of guest bans that cnt-landing's BanUserApiService deliberately leaves out. */
@Injectable({ providedIn: 'root' })
export class AdminGuestBanApiService {
  private readonly http = inject(HttpClient);

  listForGuest(guestId: number): Observable<IGuestBanDetail[]> {
    return this.http.get<IGuestBanDetail[]>(`${API_URL}/guest/${guestId}/bans`);
  }

  /** Reverses a ban — hosts have no undo, so this is the only way back. */
  unban(guestId: number, reservationId: number): Observable<ISuccessMessage> {
    return this.http.delete<ISuccessMessage>(`${API_URL}/guest/${guestId}/ban/${reservationId}`);
  }
}
